import { DotPhraseScope } from "../constants/dot-phrases";

export interface InsertableDotPhrase {
  id: string;
  trigger: string;
  title: string;
  preview: string;
  bodyHtml: string;
  scope: DotPhraseScope;
}

export const LOAD_INSERTABLE_DOT_PHRASES_FAILURE = {
  MissingPractice: "missing-practice",
  MissingPractitioner: "missing-practitioner",
  LoadFailed: "load-failed",
} as const;

export type LoadInsertableDotPhrasesFailure =
  (typeof LOAD_INSERTABLE_DOT_PHRASES_FAILURE)[keyof typeof LOAD_INSERTABLE_DOT_PHRASES_FAILURE];

export type LoadInsertableDotPhrasesResult =
  | { ok: true; data: InsertableDotPhrase[] }
  | { ok: false; reason: LoadInsertableDotPhrasesFailure };
